import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faFile, faPrint } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Context
import { useAuth } from '../../../../../context/auth';

//Componentes
import TextField from '../../../../../components/TextField';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Helpers
import uuid from '../../../../../helpers/guid';
import { showMessage, showQuestion } from '../../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../../helpers/mascaras';
//API
import documento_api from '../../../../../api/documento_api';
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

//Contants
import { actionsTable } from '../../../../../constants/MaterialTable';
import formulario_api from '../../../../../api/formulario_api';


function initialStateEtapa(uuid) {
    return {
        descricao: "",
        prazoDias: "",
        excluido: "false",
        avancaEtapaPrazoExcedido: "false",
        roteiroFiscalizacao_Id: "",
        formulario_Id: "Nenhum",
        hash: uuid,
        responsavel: "Secretaria",
        andamento: "Inicial",
        documentos: [],
        impressoes: [],
        sequenciaDashboard: "0",
        exigeVotacaoColegiado: "false",
        exibirEtapaInfrator: "false",
        calcularJuros: "false",
        permiteAlterarEmail: "false",
        reenvioEmailAutomatico: "false",
        inicioPrazoProximoDiaUtil: "false",
        fimPrazoProximoDiaUtil: "false",
        permiteBoletoInfrator: "true",
    }
}

const initialStateDocumento = (roteiroFiscalizacaoEtapa_id) => {
    return {
        ...roteiroFiscalizacaoEtapa_id ? { roteiroFiscalizacaoEtapa_Id: roteiroFiscalizacaoEtapa_id } : {},
        documento_Id: "",
        obrigatorio: "false",
    }
}

const initialStateImpressao = (roteiroFiscalizacaoEtapa_id, sequencia = "1") => {
    return {
        ...roteiroFiscalizacaoEtapa_id ? { roteiroFiscalizacaoEtapa_Id: roteiroFiscalizacaoEtapa_id } : {},
        tipoItem: "DocumentoHtml",
        documento_Id: "",
        sequencia: sequencia,
        impressaoSeparada: "false",
    }
}

//A sequência define a ordem das páginas na impressão (o backend ordena por ela).
//Ao adicionar um item, sugere a próxima posição livre — o usuário pode sobrescrever.
const proximaSequencia = (impressoes) => {
    const maior = (impressoes ?? []).reduce((maximo, item) => Math.max(maximo, Number(item.sequencia) || 0), 0);
    return String(maior + 1);
}

//O select trabalha com "true"/"false"; o backend devolve booleano.
const paraTextoBooleano = (valor) => valor === true || valor === "true" ? "true" : "false";

//Tipos de item aceitos pelo motor de impressão (RoteiroFiscalizacaoService.TiposItemImpressaoValidos)
const tiposItemImpressao = [
    { value: "DocumentoHtml", label: "Documento cadastrado" },
    { value: "AnexoAcao", label: "Anexo do infrator na ação" },
    { value: "CTR_RCC", label: "Ficha da CTR (RCC)" },
    { value: "FichaProtocoloROC", label: "Ficha do Protocolo (Sistema de Cadastros)" },
    { value: "FichaInfracao", label: "Ficha do Auto de Infração" },
    { value: "FichaFiscalizacao", label: "Ficha do Auto de Fiscalização" },
    { value: "ComprovanteEnvioEmail", label: "Comprovante de Envio de E-mail (1ª notificação)" },
];

const rotuloTipoItemImpressao = (tipoItem) => tiposItemImpressao.find(x => x.value === tipoItem)?.label ?? tipoItem;

const exigeDocumentoImpressao = (tipoItem) => tipoItem === "DocumentoHtml" || tipoItem === "AnexoAcao";


function Etapas({ roteiroFiscalizacao, loadRoteiroFiscalizacao, editavel }) {
    const [etapa, setEtapa] = useState(initialStateEtapa(uuid()));

    const { setLoading } = useAuth();

    //Estado de controle de visibilidade do modal dos documentos
    const [visibleModal, setVisibleModal] = useState(false);

    //Estado de controle de visibilidade do modal de parametrização de impressão
    const [visibleModalImpressao, setVisibleModalImpressao] = useState(false);

    //Estado de controle de visibilidade do formulario de cadastro de etapa
    const [visibleContainer, setVisibleContainer] = useState(false);

    //Estado de controle dos dados do documento a ser adicionado na lista
    const [documento, setDocumento] = useState(initialStateDocumento(etapa.id));

    //Estado de controle das opções de documentos
    const [documentos, setDocumentos] = useState([]);

    //Estado de controle dos erros nos campos obrigatorios de cadastro de etapa
    const [errors, setErrors] = useState({});

    //Estado de controle dos erros nos campos do documento
    const [errorsDocumento, setErrosDocumento] = useState({});

    //Estado de controle dos dados do item de impressão a ser adicionado na lista
    const [impressao, setImpressao] = useState(initialStateImpressao(etapa.id));

    //Estado de controle dos erros nos campos do item de impressão
    const [errorsImpressao, setErrorsImpressao] = useState({});

    //State para pegar formularios cadastrados
    const [listaFormularios, setListaFormularios] = useState([]);

    //Função de troca de visibilidade do modal
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
    };

    //Função de troca de visibilidade do modal de impressão.
    //Ao abrir, o formulário já vem posicionado na próxima sequência livre.
    const toggleModalImpressao = () => {
        if (!visibleModalImpressao)
            novaImpressao(etapa.impressoes);
        setVisibleModalImpressao(!visibleModalImpressao);
    };

    //Função que carrega a lista de documentos
    const loadDocumentos = () => {
        setLoading(true);
        documento_api.getListAtivos().then(response => {
            response.data.map(value => {
                value.value = value.id.toString();
                value.label = value.identificacao;

                return value;
            })
            setDocumentos(response.data);
        })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const loadFormulario = () => {
        setLoading(true);
        formulario_api.GetListAtivosByFinalidade("Análise").then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();
                return value;
            })
            setListaFormularios([...response.data, { label: "Nenhum", value: "Nenhum" }]);
        })
            .catch(ex => showMessage("Erro", ex.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDocumentos();
        loadFormulario();
    }, [])


    //Estado de controle de troca de exibição do formulario de cadastro de etapa
    const toggleFormContainer = () => {
        setVisibleContainer(!visibleContainer);
        if (visibleContainer)
            setEtapa(initialStateEtapa(uuid()));
    }

    //onChange para o documento a ser adicionado
    const onChangeDocumento = (value, e) => {
        setDocumento({
            ...documento,
            [e.name]: value ? value.value.toString() : null,
        });

    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setEtapa({
            ...etapa,
            [name]: value
        })
    }

    //onChange do campo obrigatorio do documento
    const onChangeObrigatorioDocumento = (e) => {
        const { name, value } = e.target;

        setDocumento({
            ...documento,
            [name]: value
        })
    }

    const editarDocumento = (editRow) => {
        const _editRow = { ...editRow }
        _editRow.documento_Id = _editRow.documento_Id.toString();
        setDocumento(_editRow);
    }

    const removerDocumento = (questaoRemove) => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar esse documento?", "info",
            (confirmation) => {
                if (confirmation) {
                    setEtapa({
                        ...etapa,
                        documentos: etapa.documentos.filter(value => value.tableData.id != questaoRemove.tableData.id)
                    });
                }
            })
    }

    //Actions da tabela de documentos
    const actionsDocumentos = [
        actionsTable.editar(editarDocumento),
        actionsTable.remover(removerDocumento)
    ];

    const onChangeDocumentoImpressao = (value, e) => {
        setImpressao({
            ...impressao,
            [e.name]: value ? value.value.toString() : null,
        });
    }

    //onChange genérico dos campos nativos (select simples e texto) do item de impressão.
    //Ao trocar o tipo pra um que não usa documento, zera o documento selecionado.
    const onChangeImpressao = (e) => {
        const { name, value } = e.target;

        //Trocar o tipo pode invalidar o documento já escolhido: some do combo se o tipo novo não
        //aceita documento, ou se o documento não está na lista filtrada do tipo novo (ex.: sai de
        //"Documento cadastrado" com Cota Defesa para "Anexo do infrator", que só aceita Avulso).
        const documentoContinuaValido = name === "tipoItem"
            && exigeDocumentoImpressao(value)
            && documentos.some(doc => doc.value == impressao.documento_Id);

        setImpressao({
            ...impressao,
            [name]: value,
            ...(name === "tipoItem" && !documentoContinuaValido ? { documento_Id: null } : {}),
        })
    }

    //Índice do item em edição na lista (null = está adicionando um novo).
    //Antes o pareamento era feito por tableData.id, que a TabelaListagem só injeta depois
    //de renderizar: item recém-adicionado ficava sem tableData e a edição duplicava a linha.
    const [indiceImpressaoEdicao, setIndiceImpressaoEdicao] = useState(null);

    const novaImpressao = (impressoes) => {
        setIndiceImpressaoEdicao(null);
        setImpressao(initialStateImpressao(etapa.id, proximaSequencia(impressoes)));
        setErrorsImpressao({});
    }

    const editarImpressao = (editRow) => {
        const _editRow = { ...editRow };
        if (_editRow.documento_Id != null)
            _editRow.documento_Id = _editRow.documento_Id.toString();
        //O registro vindo do banco traz número e booleano; os campos do formulário são texto.
        _editRow.sequencia = String(_editRow.sequencia ?? "");
        _editRow.impressaoSeparada = paraTextoBooleano(_editRow.impressaoSeparada);
        setIndiceImpressaoEdicao(etapa.impressoes.indexOf(editRow));
        setImpressao(_editRow);
        setErrorsImpressao({});
    }

    const removerImpressao = (itemRemove) => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar esse item de impressão?", "info",
            (confirmation) => {
                if (confirmation) {
                    const _impressoes = etapa.impressoes.filter(value => value !== itemRemove);
                    setEtapa({ ...etapa, impressoes: _impressoes });
                    novaImpressao(_impressoes);
                }
            })
    }

    //Actions da tabela de impressão
    const actionsImpressoes = [
        actionsTable.editar(editarImpressao),
        actionsTable.remover(removerImpressao)
    ];

    //Função do botão de editar etapa
    const editar = (rowData) => {
        setEtapa({
            ...rowData,
            exigeVotacaoColegiado: rowData?.exigeVotacaoColegiado ?? false,
            permiteBoletoInfrator: rowData?.permiteBoletoInfrator ?? true
        });
        setVisibleContainer(true);
    }

    const visualizar = (rowData) => {
        setEtapa({
            ...rowData,
            permiteBoletoInfrator: rowData?.permiteBoletoInfrator ?? true
        });
        setVisibleContainer(true);
    }

    //Função do botão de remover etapa
    const remover = (rowData) => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar essa etapa?\n Esta ação é irreversível", "info",
            async (confirmation) => {
                if (!confirmation)
                    return;

                setLoading(true);

                try {
                    await roteiroDeFiscalizacao_api.DeleteRoteiroFiscalizacaoEtapa(rowData.id);
                    toggleFormContainer();
                    //Recarrega antes de avisar: o "Sucesso" só aparece com a lista já atualizada.
                    await loadRoteiroFiscalizacao();
                    showMessage("Sucesso", "Etapa deletada com sucesso", "success", null);
                } catch (err) {
                    showMessage("Aviso", err?.message ?? "Erro na operação.", "error", null);
                } finally {
                    setLoading(false);
                }
            })
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editar), actionsTable.remover(remover)]
            : [actionsTable.visualizar(visualizar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Prazo em dias", objectValue: "prazoDias", align: "left" },
        { value: "Responsavel", objectValue: "responsavel", align: "left" },
        { value: "Sequência dashboard", objectValue: "sequenciaDashboard", align: "left" },
    ]

    //Cabeçalhos que a tabela de documentos
    const headersDocumentos = [
        { value: "Documento", objectValue: "documento", align: "left" },
        {
            value: "Obrigatório", objectValue: "obrigatorio", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{etapa.documentos[dataIndex].obrigatorio ? "Sim" : "Não"}</>
                }
            }
        },
    ]

    //Campos obrigatorios
    const camposDocumento = [
        objCampo({ name: "documento_Id", required: true })
    ];

    //A tabela é exibida na ordem de impressão. A ordenação é feita sobre uma cópia, então as
    //linhas continuam sendo os mesmos objetos de etapa.impressoes (editar/remover usam a
    //referência do objeto, não a posição na tela).
    const impressoesOrdenadas = [...etapa?.impressoes ?? []]
        .sort((a, b) => (Number(a.sequencia) || 0) - (Number(b.sequencia) || 0));

    //Cabeçalhos da tabela de itens de impressão
    const headersImpressoes = [
        {
            value: "Tipo", objectValue: "tipoItem", align: "left", options: {
                customBodyRenderLite: (dataIndex) => <>{rotuloTipoItemImpressao(impressoesOrdenadas[dataIndex].tipoItem)}</>
            }
        },
        {
            value: "Documento", objectValue: "documento", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    const item = impressoesOrdenadas[dataIndex];
                    const _documento = documentos.filter(doc => doc.value == item?.documento_Id);
                    return <>{_documento[0]?.identificacao ?? "-"}</>
                }
            }
        },
        { value: "Sequência", objectValue: "sequencia", align: "left" },
        {
            value: "Impressão Separada", objectValue: "impressaoSeparada", align: "left", options: {
                customBodyRenderLite: (dataIndex) => <>{paraTextoBooleano(impressoesOrdenadas[dataIndex].impressaoSeparada) === "true" ? "Sim" : "Não"}</>
            }
        },
    ]

    //Campos obrigatorios do item de impressão
    const camposImpressao = [
        objCampo({ name: "tipoItem", required: true }),
        ...exigeDocumentoImpressao(impressao.tipoItem) ? [objCampo({ name: "documento_Id", required: true })] : [],
    ];

    //Campos obrigatorios
    const camposObrigatorios = [
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "responsavel", required: true })
    ];

    const onChangeFormularios = (value, e) => {
        const _etapa = {
            ...etapa,
            [e.name]: value ? value.value.toString() : null,
        };
        setEtapa(_etapa);
    }

    const onSubmitDocumento = () => {
        const _documento = { ...documento };

        const _errorsDocumento = validarCampos(_documento, camposDocumento);
        setErrosDocumento(_errorsDocumento[0]);

        if (_errorsDocumento[1].length > 0)
            return;

        if (etapa.documentos.filter(x => x.documento_Id == _documento.documento_Id && x.obrigatorio == _documento.obrigatorio && (!_documento.documento_Id || _documento.documento_Id != x.id)).length > 0) {
            showMessage("Aviso", "Este documento ja foi adicionado para este tipo de requerimento", "info", null);
            return;
        }

        const _roteiroFiscalizacaoEtapaDocumento = [...!_documento.tableData ? etapa.documentos : etapa.documentos.map(value => {
            if (value.documento_Id == _documento.documento_Id) {
                _documento.obrigatorio = _documento.obrigatorio == "true" ? true : false;
                return _documento;
            }
            return value;
        })];

        if (!_documento.tableData) {
            _roteiroFiscalizacaoEtapaDocumento.push(_documento);
        }
        setEtapa({
            ...etapa,
            documentos: _roteiroFiscalizacaoEtapaDocumento
        });
        setDocumento(initialStateDocumento(etapa.id));
    }

    const onSubmitImpressao = () => {
        const _impressao = { ...impressao };

        const _errorsImpressao = validarCampos(_impressao, camposImpressao);
        setErrorsImpressao(_errorsImpressao[0]);

        if (_errorsImpressao[1].length > 0)
            return;

        //Sequência em branco não pode ir para o backend (a coluna é int e não aceita ""):
        //cai para a próxima posição livre. Por isso o campo não é marcado como obrigatório.
        if (String(_impressao.sequencia ?? "").trim() === "")
            _impressao.sequencia = proximaSequencia(etapa.impressoes);

        //Duas linhas com a mesma sequência saem em ordem indefinida do OrderBy do backend — a
        //impressão trocaria de ordem entre uma geração e outra sem ninguém mexer na parametrização.
        const sequenciaRepetida = etapa.impressoes.some((item, indice) =>
            indice !== indiceImpressaoEdicao && Number(item.sequencia) === Number(_impressao.sequencia));

        if (sequenciaRepetida) {
            setErrorsImpressao({ sequencia: true });
            showMessage("Aviso", `Já existe um item de impressão na sequência ${_impressao.sequencia}.`, "warning", null);
            return;
        }

        const _roteiroFiscalizacaoEtapaImpressao = indiceImpressaoEdicao === null
            ? [...etapa.impressoes, _impressao]
            : etapa.impressoes.map((value, indice) => indice === indiceImpressaoEdicao ? _impressao : value);

        setEtapa({
            ...etapa,
            impressoes: _roteiroFiscalizacaoEtapaImpressao
        });
        novaImpressao(_roteiroFiscalizacaoEtapaImpressao);
    }

    const onSubmit = async () => {
        const _errors = validarCampos(etapa, camposObrigatorios);
        setErrors(_errors[0]);
        if (_errors[1].length)
            return;

        setLoading(true);
        const _etapa = { ...etapa };

        _etapa.excluido = _etapa.excluido == "true";
        _etapa.roteiroFiscalizacao_Id = roteiroFiscalizacao.id;
        _etapa.formulario_Id = _etapa.formulario_Id == "Nenhum" ? null : _etapa.formulario_Id;

        //Os campos do formulário são texto, mas Sequencia é int e ImpressaoSeparada é bool no
        //contrato da API. tableData é controle interno da tabela e não faz parte do payload.
        _etapa.impressoes = (_etapa.impressoes ?? []).map(({ tableData, ...item }) => ({
            ...item,
            sequencia: Number(item.sequencia) || 0,
            impressaoSeparada: paraTextoBooleano(item.impressaoSeparada) === "true",
            documento_Id: exigeDocumentoImpressao(item.tipoItem) && item.documento_Id ? item.documento_Id : null,
        }));
    
        //loadRoteiroFiscalizacao é assíncrono: sem o await, o finally derrubava o loading antes do
        //recarregamento terminar e a tela reaparecia com os dados antigos — parecia que não salvou.
        try {
            if (_etapa.id) {
                await roteiroDeFiscalizacao_api.putRoteiroFiscalizacaoEtapa(_etapa);
                toggleFormContainer();
                await loadRoteiroFiscalizacao();
            } else {
                const response = await roteiroDeFiscalizacao_api.postRoteiroFiscalizacaoEtapa(_etapa);
                toggleFormContainer();
                await loadRoteiroFiscalizacao(response.data);
            }
        } catch (err) {
            showMessage("Erro", err?.message ?? "Erro na operação.", "error", null);
        } finally {
            setLoading(false);
        }
    }

    return <>
        <h5 className='mb-3 d-flex align-items-center justify-content-between'>Etapas {editavel ? <Button color='success' onClick={toggleFormContainer}>+ Adicionar</Button> : <></>}</h5>
        <ModalCustomized
            btnClose={true}
            isOpen={visibleModal}
            toggle={toggleModal}
            title={"Documentos"}
        >
            <Row>
                <Col md="12" lg="8">
                    <TextField
                        label={"* Documento"}
                        name={"documento_Id"}
                        onChange={onChangeDocumento}
                        type={"select"}
                        searchable
                        options={documentos}
                        value={documentos.filter(doc => doc.value == documento.documento_Id)}
                        invalid={!!errorsDocumento.documento_Id}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        type={"select"}
                        label="* Obrigatorio"
                        name={"obrigatorio"}
                        options={
                            [
                                { label: "Sim", value: "true" },
                                { label: "Não", value: "false" }
                            ]
                        }
                        onChange={onChangeObrigatorioDocumento}
                        value={documento.obrigatorio}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" className={`d-flex align-items-center justify-content-center mb-4 ${editavel ? "" : "d-none"}`}>
                    <Button
                        color={"secondary"}
                        className='me-4'
                        onClick={() => setDocumento(initialStateDocumento(etapa.id))}
                    >
                        cancelar
                    </Button>
                    <Button
                        onClick={onSubmitDocumento}
                        color={documento.id ? "warning text-white" : 'success'}
                    >
                        {documento.id ? <> <FontAwesomeIcon icon={faEdit} />  Editar</> : "+ Adicionar"}
                    </Button>
                </Col>
                <Col md="12" className='d-flex align-items-center justify-content-center'>
                    <TabelaListagem
                        title='Lista de documentos'
                        headers={headersDocumentos}
                        actions={actionsDocumentos}
                        items={etapa?.documentos?.length > 0 ? etapa.documentos.map(d => {
                            const _documento = documentos.filter(doc => doc.value == d?.documento_Id)
                            d.documento = _documento[0]?.identificacao
                            return d;
                        }) : []}
                    />
                </Col>
            </Row>
        </ModalCustomized>
        <ModalCustomized
            btnClose={true}
            isOpen={visibleModalImpressao}
            toggle={toggleModalImpressao}
            title={"Impressão Completa"}
        >
            <Row>
                <Col md="12" lg="4">
                    <TextField
                        label={"* Tipo do item"}
                        name={"tipoItem"}
                        onChange={onChangeImpressao}
                        type={"select"}
                        options={tiposItemImpressao}
                        value={impressao.tipoItem}
                        invalid={!!errorsImpressao.tipoItem}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        label={`${exigeDocumentoImpressao(impressao.tipoItem) ? "* " : ""}Documento`}
                        name={"documento_Id"}
                        onChange={onChangeDocumentoImpressao}
                        type={"select"}
                        searchable
                        options={documentos}
                        value={documentos.filter(doc => doc.value == impressao.documento_Id)}
                        invalid={!!errorsImpressao.documento_Id}
                        disabled={!editavel || !exigeDocumentoImpressao(impressao.tipoItem)}
                    />
                </Col>
                <Col md="6" lg="2">
                    <TextField
                        label={"Sequência"}
                        name={"sequencia"}
                        type={"text"}
                        mask={mascaras.numeroMask}
                        onChange={onChangeImpressao}
                        value={impressao.sequencia}
                        invalid={!!errorsImpressao.sequencia}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="6" lg="2">
                    <TextField
                        type={"select"}
                        label="* Impressão separada"
                        name={"impressaoSeparada"}
                        options={
                            [
                                { label: "Sim", value: "true" },
                                { label: "Não", value: "false" }
                            ]
                        }
                        onChange={onChangeImpressao}
                        value={impressao.impressaoSeparada}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" className={`d-flex align-items-center justify-content-center mb-4 ${editavel ? "" : "d-none"}`}>
                    <Button
                        color={"secondary"}
                        className='me-4'
                        onClick={() => novaImpressao(etapa.impressoes)}
                    >
                        cancelar
                    </Button>
                    <Button
                        onClick={onSubmitImpressao}
                        color={indiceImpressaoEdicao !== null ? "warning text-white" : 'success'}
                    >
                        {indiceImpressaoEdicao !== null ? <> <FontAwesomeIcon icon={faEdit} />  Editar</> : "+ Adicionar"}
                    </Button>
                </Col>
                <Col md="12" className='d-flex align-items-center justify-content-center'>
                    <TabelaListagem
                        title='Itens da Impressão Completa'
                        headers={headersImpressoes}
                        actions={actionsImpressoes}
                        items={impressoesOrdenadas}
                    />
                </Col>
            </Row>
        </ModalCustomized>
        <div className={`formContainer ${visibleContainer ? "" : "close"} mb-2`}>
            <Row>
                <Col md={12} lg={6}>
                    <TextField
                        name={"descricao"}
                        label={"*  Descrição"}
                        type={"text"}
                        onChange={onChange}
                        value={etapa.descricao}
                        invalid={!!errors.descricao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={6}>
                    <TextField
                        type={"select"}
                        name={"formulario_Id"}
                        label={"* Formulário"}
                        searchable
                        options={listaFormularios}
                        onChange={onChangeFormularios}
                        value={listaFormularios.filter(value => value.value == etapa.formulario_Id)}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={5}>
                    <TextField
                        name={"avancaEtapaPrazoExcedido"}
                        label={"*  Avançar automaticamente quando o prazo for excedido"}
                        type={"select"}
                        options={[
                            { value: "true", label: "Sim" },
                            { value: "false", label: "Não" }
                        ]}
                        onChange={onChange}
                        value={etapa.avancaEtapaPrazoExcedido}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"prazoDias"}
                        label={"*  Prazo em dias"}
                        type={"text"}
                        mask={mascaras.numeroMask}
                        onChange={onChange}
                        value={etapa.prazoDias}
                        invalid={!!errors.prazoDias}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"responsavel"}
                        label={"*  Responsável"}
                        type={"select"}
                        options={[
                            { value: "Secretaria", label: "Secretaria" },
                            // { value: "APP", label: "APP" },
                            { value: "Sistema", label: "Sistema" },
                            { value: "Fiscalizado", label: "Fiscalizado" }
                        ]}
                        onChange={onChange}
                        value={etapa.responsavel}
                        invalid={!!errors.responsavel}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"andamento"}
                        label={"*  Andamento"}
                        type={"select"}
                        options={[
                            { value: "Inicial", label: "Inicial" },
                            { value: "Processo", label: "Processo" },
                            { value: "Final", label: "Final" }
                        ]}
                        onChange={onChange}
                        value={etapa.andamento}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"exigeVotacaoColegiado"}
                        label={"* Exige votação por órgão colegiado"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.exigeVotacaoColegiado}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"exibirEtapaInfrator"}
                        label={"* Exibe para o Infrator"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.exibirEtapaInfrator}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"calcularJuros"}
                        label={"* Calcular Juros"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.calcularJuros}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"permiteAlterarEmail"}
                        label={"* Permite alterar E-mail"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.permiteAlterarEmail}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"reenvioEmailAutomatico"}
                        label={"* Reenvio Automático de Email"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.reenvioEmailAutomatico}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"inicioPrazoProximoDiaUtil"}
                        label={"* Início do prazo no próximo dia útil"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.inicioPrazoProximoDiaUtil}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"permiteBoletoInfrator"}
                        label={"* Infrator pode gerar boleto?"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.permiteBoletoInfrator}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"fimPrazoProximoDiaUtil"}
                        label={"* Fim do prazo no próximo dia útil"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.fimPrazoProximoDiaUtil}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"sequenciaDashboard"}
                        label={"* Sequência dashboard"}
                        type={"text"}
                        mask={mascaras.numeroMask}
                        onChange={onChange}
                        value={etapa.sequenciaDashboard}
                        disabled={!editavel}
                    />
                </Col>
                <Col xs={12} sm={6} md={6} lg={2} className='mt-2'>
                    <Button
                        className='w-100'
                        color='primary'
                        onClick={() => setVisibleModal(true)}
                    >
                        <FontAwesomeIcon icon={faFile} /> Documentos
                    </Button>
                </Col>
                <Col xs={12} sm={6} md={6} lg={3} className='mt-2'>
                    <Button
                        className='w-100 text-nowrap'
                        color='primary'
                        onClick={toggleModalImpressao}
                    >
                        <FontAwesomeIcon icon={faPrint} /> Impressão Completa
                    </Button>
                </Col>
                <Col md={12} lg={12} className={`d-flex align-items-center justify-content-center mb-3 ${editavel ? "" : "d-none"}`}>
                    <Button className='me-4' color={"secondary"} onClick={toggleFormContainer}>
                        Cancelar
                    </Button>
                    <Button color={etapa.id ? "warning text-white" : 'success'} onClick={onSubmit}>
                        {etapa.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"}
                    </Button>
                </Col>
            </Row>
        </div>
        <TabelaListagem
            actions={actions}
            title={"Lista de etapas"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={roteiroFiscalizacao.etapas}
        />
    </>;
}

export default Etapas;